import { EnumService } from "./../../../shared/services/enum.service";
import { AuthService } from "./../../../shared/services/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { ProductService } from "src/app/components/shared/services/product.service";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { CartService } from "src/app/components/shared/services/cart.service";
import { SwiperDirective, SwiperConfigInterface } from "ngx-swiper-wrapper";
import { NgxSpinnerService } from "ngx-spinner";
import { CaroucelRelacionado } from "src/app/modals/caroucel-relacionado";
import { environment } from "src/environments/environment";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ItemsService } from "src/app/services/items.service";
import { constApi } from "src/environments/constApi";
import { ProductZoomComponent } from "../../products/product-details/product-zoom/product-zoom.component";
import { ProductDailogGifComponent } from "../../products/product-details/product-dailog-gif/product-dailog-gif.component";
import { EcommerceNpService } from "src/app/components/shared/services/ecommerce-np.service";
declare var $: any;

@Component({
  selector: "app-vista-previa-detail",
  templateUrl: "./vista-previa-detail.component.html",
  styleUrls: ["./vista-previa-detail.component.sass"],
})
export class VistaPreviaDetailComponent implements OnInit {
  // getYPosition(e: Event): number {
  //   return (e.target as Element).scrollTop;
  // }

  public config: SwiperConfigInterface = {};

  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

  @ViewChild("zoomViewer", { static: true }) zoomViewer;
  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;

  public productItem: Product;
  public products: Product[] = [];

  public image: any;
  public zoomImage: any;

  public stockInicial;

  public counter: number = 1;
  fbFormProductDetail: FormGroup;
  index: number;
  bigProductImageIndex = 0;
  listBannerPub: any;
  idProducto: any;
  productCarroucel: any;
  caroucelRelacionado: CaroucelRelacionado = new CaroucelRelacionado();
  agotado: boolean = false;
  msgDisponibilidad: string = "Disponible";
  ctas: any[] = [];
  gisfArray: any[] = [];
  constructor(
    private route: ActivatedRoute,
    public productsService: ProductService,
    public dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private enumService: EnumService,
    private fb: FormBuilder,
    private ecomService: EcommerceNpService
  ) {}

  ngOnInit() {
    this.buildForm();
    if (document.querySelector("mat-sidenav-content") != null)
      document.querySelector("mat-sidenav-content").scrollTop = 0;
    this.idProducto = Number(this.route.snapshot.params["id"]);
    // console.log(this.idProducto)
    this.cargarDatos();
    this.cargarData();
    this.spinner.hide();
  }

  buildForm() {
    this.fbFormProductDetail = this.fb.group({
      cantidad: [1],
    });
  }

  cargarDatos() {
    let product: any = JSON.parse(localStorage.getItem("productDetail"));
    if (product != null) {
      this.productItem = product;
    }
    this.getRelatedProducts();
    this.loadBanner();
  }
  cargarData() {
    let param = [{ clave: "CuentaB", valor: "%" }];
    this.ecomService
      .getParam(environment.apiUrlTeso,constApi.CTASBANCOS, param)
      .subscribe((res: any) => {
        this.ctas = res.body.filter((x) => x.CuentaB != "21503063274012");
        this.ctas.forEach((x) => {
          if (x.SiglasBco == "BCP") {
            x.logo =
              "assets/img/bcp-logo.png";
          }
          if (x.SiglasBco == "BVL") {
            x.logo =
              "assets/img/interbank-logo.png";
          }
          if (x.SiglasBco == "BBVA") {
            x.logo =
              "assets/img/bbva-logo.png";
          }
        });
      });
  }
  ngAfterViewInit() {
    //#region
    let top = document.getElementById("top");
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
    //#endregion
  }

  public openProductDialog(product, bigProductImageIndex) {
    let dialogRef = this.dialog.open(ProductZoomComponent, {
      data: { product, index: bigProductImageIndex },
      panelClass: "product-dialog",
    });
    dialogRef.afterClosed().subscribe((product) => {
      if (product) {
        this.router.navigate(["/products", product.id, product.name]);
      }
    });
  }

  public selectImage(index) {
    this.bigProductImageIndex = index;
  }

  public increment() {}

  public decrement() {}

  getRelatedProducts() {
    this.productsService.getProducts().subscribe((product: Product[]) => {
      this.products = product;
    });
  }

  // Add to cart
  public addToCart(product: Product, quantity) {}

  // Add to cart
  public buyNow(product: Product, quantity) {}

  public onMouseMove(e) {}

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  public openZoomViewer() {
    this.dialog.open(ProductZoomComponent, {
      data: this.zoomImage,
      panelClass: "zoom-dialog",
    });
  }

  public calificarEstrella(id, valoracion) {}

  public loadBanner() {
    this.enumService.getBannerBPB().subscribe((res: any) => {
      this.listBannerPub = res;
      // //////console.log(this.listBannerPub);
    });
  }

  public loadRelacionados(categoria) {}

  async clickItem(row) {}
  backPage() {
    window.history.back();
  }
  enviarMensajeWsp() {}
  verGif() {
    this.dialog.open(ProductDailogGifComponent, {
      data: this.gisfArray,
      panelClass: "product-dialog",
    });
  }
}
